import { SearchResults } from '@/hooks/useSearch';

export const fullMatchUniqueSymbol = (results: SearchResults) =>
  results.reduce((acc, current) => {
    const { _highlightResult } = current;
    if (typeof _highlightResult.listings !== 'undefined') {
      const uniqueSymbol = _highlightResult.listings
        .filter((listing) => listing.uniqueSymbol.fullyHighlighted)
        .map((listing) => listing.uniqueSymbol.value.replace(/\s/g, ''));
      return acc.concat(...uniqueSymbol);
    }
    return acc;
  }, [] as string[]);
